// src/components/ThreeDModel/products/index.ts
import type { ProductDefinition } from './types'
import { product as wardrobe } from './wardrobe'
import { product as wardrobeNewCollection } from './wardrobe-new-collection'
import { product as rack } from './rack'
import { product as bedside } from './bedside'
import { product as tvStand } from './tv-stand'
import { product as officeTable } from './office-table'
import { product as table } from './table'
import { product as workTable } from './work-table'
import { product as stand } from './stand'

// All 9 product types are registered. getProduct is total (defaults to wardrobe).
const PRODUCTS: Record<string, ProductDefinition> = {
  wardrobe,
  'wardrobe-new-collection': wardrobeNewCollection,
  rack,
  bedside,
  'tv-stand': tvStand,
  'office-table': officeTable,
  table,
  'work-table': workTable,
  stand,
}

// Total function — always returns a ProductDefinition.
// Unknown or missing types fall back to the wardrobe product.
export function getProduct(type?: string): ProductDefinition {
  return (type !== undefined && type in PRODUCTS ? PRODUCTS[type] : undefined) ?? PRODUCTS.wardrobe
}

export type { ProductDefinition } from './types'
